import { FC } from "react"
import { StyleFilterWrapper, StyleSearchWrapper,StyleSearchInput } from "./style"
import { FilterProps } from "./interface"
import Svg from "../svg"
const TableFilter:FC<FilterProps> = ({
    hasSearch,
    onSearch,
    rightComponent
}) =>{
    return(
        <StyleFilterWrapper>
             {
            
                !!hasSearch && (
                    <StyleSearchWrapper>
                    <Svg svg={'search'} color={'inputBorder'} />
      
                    <StyleSearchInput
                      placeholder={
                         'Search...'
                      }
                      onChange={onSearch}
                    />
                  </StyleSearchWrapper>
                )
             }
             {
                !!rightComponent && rightComponent
             }
        </StyleFilterWrapper>
    )
}

export default TableFilter